export default {
    filter: {
        phone: 'Номер телефона с 7, 375, 371',
        email: 'Адрес электронной почты',
        name: 'ФИО',
        id: 'Номер заказа',
        pfm: 'Код магазина ПФМ',
    },

    buttonClear: 'Очистить',

    block: {
        main: 'Основная информация',
        orders: 'Заказы',
    },

    fieldsList: {
        phone: 'Номер телефона',
        email: 'Адрес электронной почты',
        name: 'ФИО',
    },

    list: {
        warning: 'Для отображения списка покупателей начните вводить текст в любом из полей',
    },

    fieldsMain: {
        phone: 'Номер телефона',
        email: 'Адрес электронной почты',
        name: 'ФИО',
        totalCount: 'Количество заказов всего',
        issuedCount: 'Количество выкупленных',
        buybackPercentage: 'Процент выкупа',
    },

    fieldsOrders: {
        id: 'Номер заказа',
        status: 'Статус обработки',
        payStatus: 'Статус оплаты',
        payType: 'Тип оплаты',
        deliveryServiceMethod: 'Метод доставки',
        deliveryServiceType: 'Тип доставки',
        dateCreate: 'Дата создания',
        pfm: 'Код ПФМ',
        city: 'Населенный пункт',
        address: 'Адрес',
        deliveryStatus: 'Статус доставки',
    },
};